import { Trans } from 'react-i18next';
import { TInsuranceDuplicatedMember } from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { Alert } from '@coverflex-tech/hypernova';
import css from './InsuranceDuplicatedFamilyMembersError.module.css';

export const InsuranceDuplicatedFamilyMembersError = ({
  duplicatedFamilyMembers,
  className,
}: TInsuranceDuplicatedFamilyMembersErrorProps) => {
  return (
    <Alert className={className} type="error">
      <div className={css.container}>
        <ul className={css.list}>
          {duplicatedFamilyMembers.map((member) => (
            <li className={css.listItem} key={member.id}>
              <Trans
                i18nKey="dashboard.insurance.upgrade_plan_confirmation_modal.duplicated_family_members_alert.list_item"
                values={{ name: member.shortName, value: member.taxId.value }}
              />
            </li>
          ))}
        </ul>
        <div>
          <Trans i18nKey="dashboard.insurance.upgrade_plan_confirmation_modal.duplicated_family_members_alert.error.description" />
        </div>
      </div>
    </Alert>
  );
};

export type TInsuranceDuplicatedFamilyMembersErrorProps = {
  duplicatedFamilyMembers: TInsuranceDuplicatedMember[];
  className?: string;
};
